// extracted by mini-css-extract-plugin
module.exports = {"secondary":"#101f43","complementary":"#ba0c2f"};